const fetchBanks = (state) => {
  state.isLoading = true
  state.error = null
  state.banks = []
}

const fetchBanksSuccess = (state, companies) => {
  state.isLoading = false
  state.error = null
  state.banks = companies
}

const fetchBanksError = (state, error) => {
  state.isLoading = false
  state.error = error
  state.banks = []
}

export default {
  fetchBanks,
  fetchBanksSuccess,
  fetchBanksError,
}
